import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup, makeStyles, createStyles, Grid } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";
import { InfoBoxNewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator } from "../core/InfoBox";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 64,
        },
    }),
);

export const NewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperatorForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR
    >();

    const convertValue = (): string => {
        if (
            values.newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator
                .value.yes
        )
            return "yes";
        if (
            values.newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator
                .value.no
        )
            return "no";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container} style={{ marginBottom: 16 }}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Montage durch Syna
                </h4>
                <InfoBoxNewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator />
                <p className={classes.p} style={{ marginBottom: 0, marginTop: 16 }}>
                    Wünschen Sie die Montage des Installationsteil durch die Syna?
                </p>{" "}
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator.value = {
                                    yes: v.includes("yes"),
                                    no: v.includes("no"),
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={8} sm={12} md={12}>
                                <FormControlLabel
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    value="yes"
                                    control={<Radio />}
                                    label="Ja"
                                    error={
                                        values
                                            .newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator
                                            .error !== null
                                    }
                                />
                                <FormControlLabel
                                    value="no"
                                    control={<Radio />}
                                    label="Nein"
                                    error={
                                        values
                                            .newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator
                                            .error !== null
                                    }
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
